module.exports = __webpack_public_path__ + "static/media/Гунькина Дарья Андреевна Волшебная книга. Воронежская обл.-2.png";